import { Component, OnInit } from '@angular/core';
import { LocationsService } from '../../locations.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MessagesService } from '../../../../messages.service';
import { Location } from '../../location.model';

@Component({
  selector: 'app-location-detail',
  templateUrl: './location-detail.component.html',
  styleUrls: ['./location-detail.component.css']
})



export class LocationDetailComponent implements OnInit {
  public location: Location;
  public modeEdit: boolean;
  public loading : boolean;
  public locationNotNull : boolean;
  constructor(private locationsService: LocationsService, private route: ActivatedRoute, private router: Router, private messagesService:MessagesService) { }

  ngOnInit() {
    const locationId: number = this.route.snapshot.params["id"];
    if ( locationId == null) {
      this.modeEdit = false;
      this.location = new Location();
      this.loading = false;
      this.locationNotNull = true;
    } else {
      this.modeEdit = true;
      this.loadLocation(locationId);
    }
  }

  private loadLocation(locationId: number): void {
    this.locationsService.getLocation(locationId).subscribe(
        data => {
          this.location = data;
          this.loading = false;
          this.locationNotNull = true;
        },
        error => { this.checkError(error,"Ha ocurrido un error al cargar la ubicación"); }
    );
}

  save() {
    let errors = this.validateLocation(this.location);
    if (errors.length > 0) {
      this.loading = true;
        this.messagesService.viewWarnings(errors);
    } else {
        this.locationsService.save(this.location).subscribe(
            data => {
              this.loading = false;
              this.locationNotNull = false;
              this.router.navigate(['./locations'])},
            error => {
                this.checkError(error, "Ha ocurrido un error al guardar la ubicación" );
            }
        );
    }
  }

  update() {
    let errors = this.validateLocation(this.location);
    if (errors.length > 0) {
        this.messagesService.viewWarnings(errors);
    } else {
        this.locationsService.update(this.location).subscribe(
            data => {  this.router.navigate(['./locations'])},
            error => {
                this.checkError(error, "Ha ocurrido un error al guardar la ubicación" );
            }
        );
    }
  }

  inactive(locationId: number){
    this.loading = true;
    this.locationsService.inactive(locationId).subscribe(
        data =>{
          console.log("INACTIVANDO");          
          this.loading = false;
          this.loadLocation(locationId);
        },
        error => { this.checkError(error,"Ha ocurrido un error al inactivar la ubicación") }
        );
  }

  active(locationId: number){
    this.loading = true;
    this.locationsService.active(locationId).subscribe(
        data => {
          this.loading = false;
          this.loadLocation(locationId)
        },
        error => { this.checkError(error,"Ha ocurrido un error al activar la ubicación") }
        );
  }

  private validateLocation(pLocation: Location): string[] {
    let errors: string[] = [];
    if (pLocation.description == null || pLocation.description.trim().length == 0) {
        errors.push('Debe ingresar la descripción');
    }
    return errors;
  }

  private checkError(error: any, defaultMessage: string) {
    this.messagesService.checkError(error, defaultMessage);
  }

}
